import { useEffect } from 'react';

function PromoFetcher() {
  const PROMO_URL = 'https://tatauy.myvtex.com/_v/get-oca-promotion-details';
  const CACHE_KEY = 'ocaPromoInfo';
  const CACHE_EXPIRY_KEY = 'ocaPromoExpiry';
  const CACHE_DURATION = 2 * 60 * 60 * 1000; // 2 hours in milliseconds

  const fetchAndCachePromo = async () => {
    try {
      const response = await fetch(PROMO_URL);
      const promosArray = await response.json();
      const now = Date.now();

      localStorage.setItem(CACHE_KEY, JSON.stringify(promosArray));
      localStorage.setItem(CACHE_EXPIRY_KEY, (now + CACHE_DURATION).toString());
    } catch (error) {
      console.error('Error fetching promo info:', error);
    }
  };

  useEffect(() => {
    try {

      if (!window?.localStorage) return;
      const now = Date.now();
      const cachedExpiry = parseInt(localStorage?.getItem(CACHE_EXPIRY_KEY) || '0', 10);

      if (now > cachedExpiry) {
        fetchAndCachePromo();
      }
    } catch (error) {
      console.error('Error in PromoFetcher useEffect:', error);
    }
  }, []);

  return null;
}
export default PromoFetcher;